import { useParams } from '@tanstack/react-router';

/**
 * Gets the current venue slug from the URL path.
 * Works in any route under /$venueSlug.
 */
export const useCurrentVenueSlug = (): string => {
  const params = useParams({ strict: false }) as { venueSlug?: string };
  if (!params.venueSlug) {
    throw new Error(
      'useCurrentVenueSlug must be used within a /$venueSlug route'
    );
  }
  return params.venueSlug;
};
